/*
Diese Datei nicht importieren, sie wird nur verwendet um die environment.ts im Build-Prozess zu ersetzen.
 */
export const environment = {
    production: true,
    neoskopBrokerUrl: 'https://www.vhv.de/api/v1/brokercontact/',
    logoUrl: 'https://www.vhv.de/baugeraete',
    dankeSeiteUrl: 'https://www.vhv.de/firmen',
    version: require('../../package.json').version,
};
